import { t } from '../../i18n.es.js';
import React, { useState } from 'react';
import { styled, Button, SvgIcon } from '@teko/ui';
import { RefreshOutlined } from '@teko/ds-icon';
import { MiniDropdown } from '../../Common/MiniDropdown/MiniDropdown.es.js';
import { ListTile } from '../../Common/ListTile/ListTile.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  a {
    text-decoration: unset;
  }
`;
const RightWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;
const StyledButton = styled(Button)`
  margin-right: 0.5rem;
`;
const StyledListTile = styled(ListTile)`
  padding: 0.4rem 0.6rem;
  font-size: 0.875rem;
`;
const BuildPcTabs = (_a) => {
  var _b = _a, {
    onClickTab,
    onClickCompare,
    onResetConfig,
    lsActiveTab
  } = _b, props = __objRest(_b, [
    "onClickTab",
    "onClickCompare",
    "onResetConfig",
    "lsActiveTab"
  ]);
  const [activeTab, setActiveTab] = useState(lsActiveTab || 0);
  return /* @__PURE__ */ React.createElement(Wrapper, __spreadValues({}, props), /* @__PURE__ */ React.createElement("div", null, [0, 1, 2].map((tab) => /* @__PURE__ */ React.createElement(StyledButton, {
    variant: tab === activeTab ? "primary" : "normal",
    onClick: () => {
      setActiveTab(tab);
      onClickTab && onClickTab(tab);
    },
    key: tab
  }, t("C\u1EA5u h\xECnh"), " ", tab + 1))), /* @__PURE__ */ React.createElement(RightWrapper, null, /* @__PURE__ */ React.createElement(StyledButton, {
    variant: "primary",
    onClick: onResetConfig
  }, t("T\u1EA1o l\u1EA1i"), /* @__PURE__ */ React.createElement(RefreshOutlined, {
    color: "white",
    size: 16,
    style: { marginLeft: "0.5rem" }
  })), /* @__PURE__ */ React.createElement(MiniDropdown, {
    text: t("T\u1EA3i c\u1EA5u h\xECnh")
  }, /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(StyledListTile, {
    leading: /* @__PURE__ */ React.createElement(SvgIcon, {
      name: "pdf",
      size: 16
    }),
    onClick: () => window.print(),
    title: "PDF"
  })))));
};

export { BuildPcTabs };
